<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false">

    <h1>{{ $t('skirental.wishes.pick') }}</h1>

    <p style="margin-bottom: 1.5rem;margin-top:1rem;">Du kan välja flera. Om du inte har några särskilda önskemål, välj det nedan.</p>

    <div>

    <div class="flex">
      <div v-for="(wish) in getWishes()" :key="wish.key">
        <Checkbox 
          :label="wish.label"
          label-position="right"
          :value="true"
          :valuebinder.sync="wishes[wish.key]"
          type="checkbox"
          special-class="wishes"
          />
      </div>
    </div>
    <div style="clear:both;"></div>
  </div>

    <div>
      <h5 class="multi">{{ $t('skirental.wishes.other') }}</h5>
      <div class="flex" style="width: 100%;max-width:500px;">
        <div class="full">
          <p>{{ $t('skirental.wishes.other-help') }}</p>
          <textarea rows="2" class="text-input" v-model="wishes.freeText" />
        </div>
      </div>
      <div style="clear:both;"></div>
    </div>

    <div class="center">
      <button class="small" @click="clicked">{{ $t('skirental.wishes.save') }}</button>
    </div>

  </Modal>
</template>

<script>
import Modal from '@/components/components/Modal';
import Checkbox from '@/components/components/Checkbox';
import { mapMutations } from 'vuex';

import schoolWishes from '@/mixins/schoolWishes';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    Checkbox,
  },
  mixins: [schoolWishes],
  data() {
    return {
      wishes: {},
    };
  },
  beforeMount() {
    /* eslint-disable */
    for (let i in this.params.wishes) {
      this.$set(this.wishes, i, this.params.wishes[i]);
    }

    this.availableWishes = JSON.parse(JSON.stringify(this.params.availableWishes));
    /* eslint-enable */
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    clicked() {
      this.params.click(this.wishes);
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.flex
  display flex
  flex-wrap wrap
  justify-content space-between
  max-width 380px
  div
    width 100%
    text-align left
    margin-bottom 10px
    button
      width 90%

.text-input
  input-border()
  font-size: 1.2em
  width 100%

h5
  united-heavy()
  font-size 14px
  font-weight 900
  letter-spacing 0.4px
  color #1c1c1c
  text-transform: uppercase;
  position relative
  &:after
    border-bottom solid 1px #d2e4ea
    top 10px
    left 55px
    position absolute
    width calc(100% - 55px - 20px)
    content ""
  &.multi
    &:after
      left 150px
      width calc(100% - 150px - 20px)
</style>



// WEBPACK FOOTER //
// SkiSchoolWishes.vue?062bf14e